import { organisationConstants } from '../../../_constants/organisation.constants';
import { bulkDownloadPermissions } from '../../../_services';

export const BulkDownloadActions = {
    addBulkDownloadPermissions,
    removeBulkDownloadPermissions,
    checkBulkDownloadPermissions,
    downloadBulkReport
}

function addBulkDownloadPermissions(data, callback) {
    return dispatch => {
        dispatch(request());
        bulkDownloadPermissions.addBulkDownloadPerm(data)
            .then(
                bulkDownload => {
                    dispatch(success({bulkDownload}));
                    if(callback) {
                        callback(null, bulkDownload); // Return the success response in the callback
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(error, null); // Return the error response in the callback
                    }
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_ADD_BULK_DOWNLOAD_API } }
    function success(bulkDownload) { return { type: organisationConstants.RECIEVE_ADD_BULK_DOWNLOAD_API, bulkDownload  } }
    function failure(error) { return { type: organisationConstants.ERROR_ADD_BULK_DOWNLOAD_API, error } }
}


function removeBulkDownloadPermissions(data, callback) {
    return dispatch => {
        dispatch(request());
        bulkDownloadPermissions.removeBulkDownloadPerm(data)
            .then(
                bulkDownload => {
                    dispatch(success({bulkDownload}));
                    if(callback) {
                        callback(null, bulkDownload); // Return the success response in the callback
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(error, null); // Return the error response in the callback
                    }
                }
            );
    };


    function request() { return { type: organisationConstants.REQUEST_REMOVE_BULK_DOWNLOAD_API } }
    function success(bulkDownload) { return { type: organisationConstants.RECIEVE_REMOVE_BULK_DOWNLOAD_API, bulkDownload  } }
    function failure(error) { return { type: organisationConstants.ERROR_REMOVE_BULK_DOWNLOAD_API, error } }
}

function checkBulkDownloadPermissions(data, callback) {
    return dispatch => {
        dispatch(request());
        bulkDownloadPermissions.checkBulkDownloadPerm(data)
            .then(
                 bulkDownload => {
                    dispatch(success({bulkDownload}));
                    if(callback) {
                        callback(bulkDownload)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(error, 'ERROR');
                    }
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_CHECK_BULK_DOWNLOAD_API } }
    function success(bulkDownload) { return { type: organisationConstants.RECIEVE_CHECK_BULK_DOWNLOAD_API, bulkDownload  } }
    function failure(error) { return { type: organisationConstants.ERROR_CHECK_BULK_DOWNLOAD_API, error } }
}

function downloadBulkReport(data, callback) {
    return dispatch => {
        dispatch(request());
        bulkDownloadPermissions.downloadBulkReportService(data)
            .then(
                 bulkDownload => {
                    dispatch(success({bulkDownload}));
                    if(callback) {
                        callback(bulkDownload)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(error, 'ERROR');
                    }
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_REPORT_BULK_DOWNLOAD_API } }
    function success(bulkDownload) { return { type: organisationConstants.RECIEVE_REPORT_BULK_DOWNLOAD_API, bulkDownload  } }
    function failure(error) { return { type: organisationConstants.ERROR_REPORT_BULK_DOWNLOAD_API, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/organisations/bulkDownloadPermissions/index.js